import { useEffect } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import routerPaths from './util/routerPaths';
import { getLogger } from '../util/logger';

const logger = getLogger('Page404');

function Page404() {
  const history = useHistory();

  useEffect(() => {
    logger.debug(`404 Page Not Found: ${history.location.pathname}`);
  }, [history.location.pathname]);

  return (
    <Card style={{ marginTop: '2rem' }}>
      <Card.Header style={{ fontSize: '7rem' }}>404</Card.Header>
      <Card.Body>
        <Card.Title style={{ fontSize: '2rem' }}>Sorry!</Card.Title>
        <Card.Text style={{ fontSize: '1.2rem' }}>
          The Page You Were Looking For Was Not Found
        </Card.Text>
        <Button
          variant="link"
          onClick={() => {
            history.goBack();
          }}
        >
          {'<'} GO BACK
        </Button>
        <br />
        <Button
          variant="link"
          onClick={() => {
            history.push(routerPaths.HOME);
          }}
        >
          HOME
        </Button>
      </Card.Body>
    </Card>
  );
}

export default Page404;
